<div class="loginbox">
        <form [formGroup]="User">
            <div *ngIf="!Type.isUnlock" class="flabel">would you like to lock this user account?</div>
            <div *ngIf="Type.isUnlock" class="flabel">would you like to unlock this user account?</div>
            <div class="no" (click)="closedialog()">No</div>
            <div *ngIf="!Type.isUnlock" style="width:50%" class="yes" (click)="lock()">Yes</div>
            <div *ngIf="Type.isUnlock" style="width:50%" class="yes" (click)="unlock()">Yes</div>
        </form>
</div>